// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { Pagination } from '../common'
import { REQUIRED } from 'errors'

import {
  FieldsWrapper,
  PaginationRow,
} from './styles'

import {
  NewProject,
  ProjectStatus,
  UserNameMultiSelect,
} from './components'

import {
  Field,
  reduxForm,
} from 'redux-form'

import {
  SubmitErrors,
  UpdatedLabeledInput,
} from 'components/Form'

const idRoot = 'project-management-search'

const Form = ({ error, form, handleSubmit }) => (
  <form
    className={idRoot}
    id={idRoot}>
    <SubmitErrors
      error={error}
      idRoot={form}
      sourceForm={form} />
    <FieldsWrapper>
      <UserNameMultiSelect idRoot={idRoot} />
      <Field
        autoFocus={true}
        className={'project-name'}
        component={UpdatedLabeledInput}
        id={`${idRoot}-project-name`}
        label={'Project Name'}
        name={'projectName'} />
      <button
        className={'search-button btn search-button'}
        id={`${idRoot}-submit`}
        onClick={handleSubmit}
        type={'submit'} />
      <NewProject />
      <ProjectStatus
        idRoot={`${idRoot}-project-status`}
        sourceForm={form} />
    </FieldsWrapper>
    <PaginationRow>
      <Pagination
        idRoot={`${form}-`}
        sourceForm={form} />
    </PaginationRow>
  </form>
)

Form.propTypes = {
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
}

// a user must be specified when searching for projects here.
const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const err = {}
  if (!v.createUserId || !v.createUserId.userId) {
    err.createUserId = REQUIRED
  }
  return err
}

export default reduxForm({
  destroyOnUnmount: false,
  validate,
})(Form)
